import { useState, useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import ReactGA from "react-ga";
import { AnimatePresence } from "framer-motion";
import { ToastContainer } from "react-toastify";
//
import Header from "./components/Header";
import Cookie from "./components/Cookie";
import Menu from "./components/Menu";
//
import NoRoute from "./pages/404";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Home from "./pages/Home";
import Loading from "./pages/Loading";
import Privacy from "./pages/Privacy";
import Work from "./pages/Work";
import WorkItem from "./pages/WorkItem";
import "./theme/main.scss";

ReactGA.initialize("UA-203057043-2");

function App() {
  const [isLoading, setIsLoading] = useState(false);
  const [menuState, setMenuState] = useState(false);
  const location = useLocation();

  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  useEffect(() => {
    setTimeout(() => setIsLoading(true), 2500);
  }, []);

  const ScrollToTop = ({ children }) => {
    const { pathname } = useLocation();

    useEffect(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    }, [pathname]);

    return <>{children}</>;
  };

  return (
    <>
      {!isLoading ? (
        <AnimatePresence mode="wait">
          <Loading />
        </AnimatePresence>
      ) : (
        <AnimatePresence
          mode="wait"
          initial={false}
          onExitComplete={() => window.scrollTo(0, 0)}
        >
          <main className="App">
            <Header menuState="" setMenuState={setMenuState} />
            <Menu menuState={menuState} setMenuState={setMenuState} />
            <Cookie />
            <ToastContainer
              position="top-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
            <ScrollToTop>
              <Routes location={location} key={location.pathname}>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/privacy-policy" element={<Privacy />} />
                <Route path="/work/:slug" element={<WorkItem />} />
                <Route path="/work" element={<Work />} />
                <Route path="*" element={<NoRoute />} />
              </Routes>
            </ScrollToTop>
          </main>
        </AnimatePresence>
      )}
    </>
  );
}

export default App;
